/* global axios */
import ApiClient from './ApiClient';

class KanbanCardsAPI extends ApiClient {
  constructor() {
    super('kanban_cards', { accountScoped: true });
  }

  get(kanbanBoardId) {
    return axios.get(this.url, { params: { kanban_board_id: kanbanBoardId } });
  }

  archived(params = {}) {
    return axios.get(`${this.url}/archived`, { params });
  }

  movements(cardId) {
    return axios.get(`${this.url}/${cardId}/movements`);
  }
}

export default new KanbanCardsAPI();
